var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "contactum-fields" }, [
    _c("p", [_vm._v(" key: " + _vm._s(_vm.field.name) + " ")]),
    _vm._v(" "),
    _c("p", [_vm._v(" value: " + _vm._s(_vm.field.meta_value) + " ")]),
    _vm._v(" "),
    _vm.field.help
      ? _c("span", { domProps: { innerHTML: _vm._s(_vm.field.help) } })
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }